import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Späť',
      changePassword: 'Zmeniť heslo',
      copiedVaultId: 'Skopírované!',
      copyVaultID: 'Kopírovať ID Vault',
      create: 'Vytvoriť',
      next: 'Ďalej',
      notSure: 'Nie som si istý/á',
      signUp: 'Prihlásiť sa',
      submit: 'Podať',
      updatePassword: 'Aktualizovať heslo',
    },
    Errors: {
      createReportFailed: 'Nastala chyba pri vytváraní záznamu.',
    },
    ReportStatus: {
      CLOSED: 'Uzatvorené',
      INVESTIGATING: 'Vyšetruje sa',
      NEW: 'Podané',
      READ: 'Prečítané',
    },
    general: {
      navbar: {
        caseSettings: 'Nastavenia prípadu',
        changePassword: 'Zmeniť heslo',
        logOut: 'Odhlásiť sa',
        notifications: 'Oznámenia',
        notificationsDrawer: {
          appFileScanFailed: 'Súbor neprešiel bezpečnostnou kontrolou',
          appReportMatch: 'Váš záznam GoTogether bol nájdený.',
          appReportReassigned: 'Bol pridelený nový manažér prípadov.',
          case: 'Prípad',
          caseAssigned: 'Prípad priradený vám',
          caseImporterJobCompleted: {
            PartialSuccess: 'Import vášho prípadu bol dokončený s chybami',
            failure: 'Import vášho prípadu zlyhal',
            success: 'Import vášho prípadu prebehol úspešne',
          },
          caseLinked: 'Prípad spojený',
          caseTeamInvite: 'Pridané k prípadu',
          caseUnlinked: 'Prípad odpojený',
          dataSanitisation: 'Podrobnosti správy aktualizované',
          emptyDescription: 'Skontrolujte neskôr nové oznámenia',
          emptyTitle: 'Ste všetko dohnali',
          importId: 'Importovať ID:',
          learnMore: 'Dozvedieť sa viac',
          markAllAsRead: 'Označiť všetko ako prečítané',
          newMessage: 'Nová správa',
          newReport: 'Nová správa prijatá',
          permissionRemoved: 'Odstránený z prípadu',
          postSSubmissionFile: 'Pridaný/é súbor(y) s dôkazmi',
          report: 'Správa',
          reportAssigned: 'Správa priradená vám',
          reportStatusChange: 'Stav správy sa zmenil',
          reporterAnonymised: 'Vaše detaily boli anonymizované',
          reporterReportSubmitted: {
            subtitle: 'Odporúčame uložiť kópiu vašej správy',
            title: 'Podaná správa',
          },
          mitigationPlanReminder: 'Vyžaduje sa schválenie plánu zmierňovania',
          staleCase: 'Nevyriešený prípad',
        },
        privacyStatement: 'Oznámenie o ochrane osobných údajov',
        reporter: {
          myReports: 'Moje správy',
        },
        settings: 'Nastavenia',
        technicalSupport: 'Technická podpora',
        title: 'Účet',
      },
      time: {
        day: 'Deň',
        days: 'Dni',
        hour: 'Hodina',
        hours: 'Hodiny',
        minute: 'Minúta',
        minutes: 'Minúty',
        second: 'Druhý',
        seconds: 'Sekundy',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonymný',
        autoTranslate: 'Auto-preklad je východziskovo vypnutý.',
        backToMessages: 'Späť na správy',
        caseSettings: 'Nastavenia puzdra.',
        changeInProfile:
          'Ak chcete zmeniť toto nastavenie, môžete tak urobiť vo svojom profile',
        deletedByMessage: 'Vymazané {{author}}',
        deletedMessageLabel: 'Táto správa bola odstránená',
        description:
          'Keď je zapnutý automatický preklad, všetky správy v správach budú\n          automaticky preložené pomocou AI na základe predvoleného jazyka\n          vybraného vo vašom prehliadači.',
        descriptionSecondHalf:
          'Pôvodná verzia všetkých správ je vždy zachovaná a možno ju nájsť v chate.',
        messagePlaceholder: 'Začnite písať...',
        messageSettings: 'Nastavenia správ.',
        originalMessages: 'Pôvodný',
        showMoreBanner: 'Dozvedieť sa viac o automatických prekladoch',
        titlev2: 'Čítajte všetky správy vo svojom preferovanom jazyku.',
        translatedMessageLabel: 'Preložená správa',
        translatedMessages: 'Preložené',
        understood: 'Rozumieť',
      },
      Country: {
        description: 'V ktorej krajine pôsobíte?',
        header: 'V ktorej krajine pôsobíte?',
        noOptions: 'Žiadne krajiny sa nenašli',
        other: 'Iné',
        placeholder: 'Hľadajte krajinu...',
      },
      CreatePublicReport: {
        createReport: 'Vytvoriť nové heslo',
        helpPage: 'Choďte na našu stránku s pomocou',
        loginToOpr: 'Prihláste sa na sledovanie správ',
        or: 'alebo',
        passwordPlaceholder: 'Zadať heslo',
        phoneNumberLoginFailed:
          'Prihlásenie zlyhalo, telefónne číslo / pin je nesprávne',
        phoneNumberPlaceholder: 'Zadajte svoje telefónne číslo',
        phoneNumberTooltip:
          'Zadajte telefónne číslo, ktoré ste použili na kontaktovanie VaultTalk',
        pinPlaceholder: 'Zadajte PIN',
        reportIntroductionParagraph1:
          'Pri hlásení incidentu vám budú položené niekoľko otázok, ktoré vám pomôžu dokumentovať vaše skúsenosti.',
        reportIntroductionParagraph2:
          'Predtým, ako odošlete, máte možnosť zostať anonymný na ochranu svojho súkromia.',
        reportIntroductionParagraph3:
          'Po odoslání sa môžete kedykoľvek prihlásiť a sledovať priebeh svojej správy a komunikovať s manažérom prípadu.',
        reportIssue: 'Nahlásiť prípad',
        usernameLoginFailed:
          'Prihlásenie zlyhalo, používateľské meno / heslo je nesprávne',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Je potrebné uviesť vzťah k spoločnosti',
            reportedCategoryRequired: 'Požadovaná je kategória hlásení',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Zadajte svoj e-mail alebo ID Vault',
        vaultIdTooltip:
          'Pre anonymné správy je ID Vaultu alfanumerické. Ak správa nebola anonymná, ID Vaultu je vaša emailová adresa.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Vaše heslo',
        yourPhoneNumber: 'Vaše telefónne číslo',
        yourPin: 'Váš 6-miestny PIN',
        yourVaultId: 'Vaša Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Logo spoločnosti',
        openReporting: 'Otvoriť podávanie správ',
        userSettings: 'Používateľské nastavenia',
      },
      Date: {
        approximateDescription:
          'Pamätáte si približný dátum, kedy sa udalosť odohrala?',
        approximatePlaceholder:
          'Príklad: pred 6 mesiacmi / minulý rok / minulý november',
        cancel: 'zrušiť',
        clear: 'anulovať',
        description: 'Pamätáte si dátum, kedy sa udalosť odohrala?',
        header: 'V ktorý deň sa udalosť odohrala?',
        ok: 'ok',
        placeholder: 'Príklad: 21. jún 2020',
      },
      Description: {
        whatHappened: 'Čo sa stalo?',
        whatHappenedPlaceholder: 'Použite vlastné slová...',
        whatHappenedText: 'Vlastnými slovami opíšte, čo sa stalo',
      },
      Details: {
        disclaimer:
          'Tieto podrobnosti budú zverejnené vo vašej správe. Ak si prajete zostať anonymný, uistite sa, že neobsahujú žiadne identifikačné informácie.',
        emailPlaceholder: 'Email (voliteľné)',
        fullNamePlaceholder: 'Meno a priezvisko (voliteľné)',
        header: 'Vaše údaje',
        nonAnonSubtitle:
          'Prosím, uveďte buď svoje meno alebo emailovú adresu. Ak chcete dostávať upozornenia o tejto správe, pridajte nižšie vhodnú emailovú adresu.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Celé meno',
        subtitle:
          'Ak chcete dostávať upozornenia o tejto správe, pridajte nižšie vhodnú emailovú adresu.',
      },
      Emotion: {
        description: 'Ako ste sa pri tom cítili? Aké to malo dôsledky?',
        header: 'Aké to malo dôsledky?',
        placeholder: 'Začnite písať...',
      },
      Evidence: {
        addedHeading: 'Pridané',
        deletedMessage: 'bol zmazaný',
        deletedStatus: 'Vymazané',
        failedToOpenFileMessage:
          'Nepodarilo sa otvoriť súbor. Prosím, skúste to znova.',
        fileStatuses: {
          infectedUpload: 'Označené bezpečnostnou kontrolou',
          passedUpload: 'Prešiel bezpečnostnou kontrolou',
          pendingUpload: 'Prebieha kontrola bezpečnosti',
          readyForDownload: 'Pripravené na stiahnutie',
        },
        mobileErrorMessage:
          'Označené súbory: napíšte správe svojmu správcovi prípadov',
        nameHeading: 'Meno',
        statusHeading: 'Stav',
        tableTitle: 'Dôkaz',
        webErrorMessage:
          'Označené súbory: Ak boli vaše súbory označené, prosím, kontaktujte manažéra prípadu.',
      },
      FileUpload: {
        addFiles: 'Pridať súbory',
        addMoreFiles: 'Pridajte viac súborov',
        confirm: 'Potvrdiť',
        description:
          'Pridávanie súborov ako dôkazov môže pomôcť podporiť efektívnosť riešenia vaším správcom prípadov. Prosím, zvážte obsah súboru (vrátane metadát súboru), ak chcete zostať anonymný a rešpektujte práva ostatných jednotlivcov a platné zákony.',
        dragDrop: 'Sem presuňte súbory alebo',
        errorMessage:
          'Súbor(y) sa nepodarilo odovzdať kvôli chybe siete. Kliknite nižšie a pošlite správu svojmu správcovi prípadov o asistenciu.',
        fileLimit: 'Obmedzenie veľkosti pre každý súbor: 100MB',
        fileUploadLimitText: 'Môžete nahrať iba 10 súborov.',
        header: 'Pridať dôkaz',
        helpArticle: 'pomocný článok',
        highlighted: 'prechádzať súbory',
        information: 'Podporované typy súborov',
        moreInformation:
          'Pre viac informácií, prosím, pozrite sa na toto <a>pomocný článok</a>',
        postSubmissionErrorMessage:
          "Nepodarilo sa nám odoslať vaše súbory kvôli systémovej chybe. Prosím, znova vyberte možnosť 'potvrdiť'.",
        tooltipAudio: 'Zvuk:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenty:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Obrázky:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Súbor je príliš veľký',
          invalidFileType: 'Nepodporovaný typ súboru: {{extension}}',
          systemError: 'Systémová chyba',
          tooManyFiles: 'Maximálny počet súborov je {{maxFiles}}',
        },
        uploadFiles: 'Nahrať súbory',
      },
      Loading: {
        loading:
          'Prosím, počkajte, kým odošleme vašu správu prípadovému manažérovi...',
        postSubmissionLoading:
          'Prosím čakajte, kým odosielame váš(e) súbor(y)...',
      },
      Location: {
        description: 'Kde sa to stalo?',
        header: 'Kde sa to stalo?',
        placeholder: 'Príklad: v kancelárii',
      },
      MessageListBox: {
        messageCaseManager: 'Napísať správu prípadovému manažérovi',
        report: 'Záznam {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Preklad vypnutý',
        enableTranslationLabelEnabled: 'Preklad povolený',
        enableTranslationsDescription:
          'Povoľte automatické preklady a prečítajte si všetky správy o správach vo vašom preferovanom jazyku. Preložený jazyk je založený na jazyku vybranom na vašom zariadení.',
        enableTranslationsHeader:
          'Povoliť automatické preklady pre správy súvisiace so správami',
        enableTranslationsSubDescriptionv2:
          'Môžete prepínať medzi preloženým a pôvodným jazykom v každom chate.',
        updateTranslationFailed: 'Aktualizácia prekladu zlyhala',
        updateTranslationSuccess:
          'Prekladové nastavenie bolo úspešne aktualizované',
      },
      Password: {
        changePasswordHeader: 'Zmeniť heslo',
        createNewPassword: 'Vytvorte si, prosím, nové heslo',
        createPasswordHeader: 'Vaše heslo',
        currentPasswordPlaceholder: 'Zadať aktuálne heslo',
        description:
          'Platné heslo musí mať aspoň 9 znakov a musí obsahovať jedno veľké písmeno a jedno číslo',
        enterCurrentPassword: 'Zadajte, prosím, svoje aktuálne heslo',
        forgottenPasswordInstructions:
          'Zadajte svoje alfanumerické ID Vault (nie vašu e-mailovú adresu) a e-mailovú adresu na obnovenie vášho hesla.',
        newDescription:
          'Vytvorte silné heslo na zabezpečenie vášho účtu. Začnite písať a uvidíte pokyny nižšie.',
        passwordPlaceholder: 'Vytvoriť heslo',
        passwordResetRequestedDescription:
          'Ak vaše ID Vault existuje v našom systéme, dostanete email s inštrukciami na resetovanie vášho hesla.',
        passwordResetRequestedHeader: 'Žiadosť o odkaz na resetovanie hesla',
        reenterPlaceholder: 'Znova zadať heslo',
        subtitle:
          'Na podanie tohto záznamu si vytvorte heslo a budete mať k nemu prístup do budúcnosti',
        yourVaultId: 'Vaše ID Vault',
        yourVaultIdPlaceholder: 'Zadajte svoje ID Vault (napr. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Nahlasujete konkrétnu osobu alebo viacero osôb? Vedeli by ste ich pomenovať alebo opísať?',
        header: 'Zúčastnené osoby',
        placeholder:
          'Začnite písať a na pridanie viacerých mien alebo opisov použite čiarku',
      },
      PoweredByVault: 'Pod záštitou {{company}}',
      PrivacyStatement: 'Vyhlásenie o ochrane súkromia produktu',
      PublicMessageList: {
        myMessages: 'Moje správy',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Dôkazy pridané do existujúcej správy',
        backToReportId: 'Späť k správe ID: {{reportId}}',
        description:
          'Pridanie súborov ako dôkazy môže pomôcť podporiť efektívnosť riešenia vašim správcom prípadu. Prosím zvážte obsah súboru (vrátane metadát súboru), ak si želáte zostať anonymný a rešpektujte práva ostatných jednotlivcov a platné zákony. Pre viac informácií, prosím pozrite sa na toto <a>pomocný článok</a>',
        header: 'Pridajte ďalšie dôkazy do správy',
        vaultTalkOpenCaseHeader: 'Pridajte dôkazy do svojej správy',
      },
      PublicReport: {
        anonymous: 'Anonymne',
        backToReports: 'Späť na záznamy',
        skipped: 'Preskočené',
      },
      PublicReportCard: {
        addEvidence: 'Pridajte ďalšie dôkazy',
        messageCaseManager: 'Napísať správu prípadovému manažérovi',
        reportId: 'Záznam ID:',
        submitted: 'Podané',
        vaultTalkClosedCaseCTA: 'Zobraziť dôkazy',
        vaultTalkOpenCaseCTA: 'Pridať dôkaz',
        viewAdditionalEvidence: 'Zobraziť ďalšie dôkazy',
        viewReport: 'Prezrieť si záznam',
      },
      PublicReportsList: {
        reportingSystem: 'Systém podávania správ',
      },
      Question: {
        placeholder: 'Začnite písať...',
        question: 'Poskytnite detaily',
        questionText:
          'Prosím, zdieľajte s nami svoj problém, aktualizáciu alebo otázku.',
      },
      Relationship: {
        header: 'Váš vzťah voči organizácii',
        tellUsAbout: 'Povedzte nám, v akom ste vzťahu voči organizácii.',
      },
      ResponsiveNavMenu: {
        messages: 'Moje správy',
        reports: 'Moje správy',
      },
      Site: {
        description: 'Na akom pracovisku pôsobíte?',
        header: 'Na akom pracovisku pôsobíte?',
        noOptions: 'Žiadne pracoviská nenájdené',
        other: 'Iné',
        placeholder: 'Hľadať pracovisko...',
      },
      SpamPuzzle: {
        dialog: 'Ak chcete pokračovať, vyriešte, prosím, túto hádanku',
      },
      SubmissionTypes: {
        reportIssue: 'Vyberte kategóriu',
        whatType: 'Vyberte kategóriu, ktorá najlepšie opisuje vašu správu',
      },
      SubmitSuccess: {
        category: '<bold>Kategória:</bold> {{category}}',
        country: '<bold>Krajina:</bold> {{country}}',
        dateSubmitted: '<bold>Dátum odoslania:</bold> {{date}}',
        recordYourVaultID: 'Zapamätajte si tieto informácie pre prihlásenie',
        successInformation: 'Viac informácií',
        successMessage:
          'Vaša správa bola odoslaná a je pripravená na kontrolu. Všetky priložené súbory, ktoré vyžadujú pozornosť, budú označené po prihlásení. Prihláste sa nižšie na zobrazenie aktualizácií správy a napíšte správu svojmu správcovi prípadu.',
        successSanitationMessage:
          'Uložte si kópiu pre svoje záznamy a svoje Vault-ID uchovávajte v bezpečí — budete ho potrebovať na prístup k aktualizáciám a komunikáciu s vašim správcom prípadu.',
        successSanitationTagline:
          'Vaša správa bola odoslaná a bezpečne uložená.',
        successThankYou: 'Ďakujem vám za vašu správu!',
        viewReport: 'Zobraziť správu',
      },
      Time: {
        approximateDescription:
          'Pamätáte si približný čas, kedy sa udalosť odohrala?',
        approximatePlaceholder: 'Príklad: ráno, poobede',
        description: 'Pamätáte si čas, kedy sa udalosť odohrala?',
        header: 'O koľkej sa to stalo?',
        invalidTime: 'Formát pre čas je HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Zmeniť heslo',
        closeDialog: 'Zatvoriť dialógové okno',
        logout: 'Odhlásiť sa',
        messageSettings: 'Nastavenia správ',
        userSettings: 'Používateľské nastavenia',
      },
      Witnesses: {
        description:
          'Povedali ste to niekomu inému alebo niekto iný videl, čo sa stalo?',
        header: 'Boli tam nejakí svedkovia?',
        placeholder: 'Začnite písať...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Odoslať správu',
        title: 'Správa Prípadového Manažéra',
        translationHeader: 'Dozviete sa viac o automatických prekladoch',
      },
      ReportCard: {
        addEvidence: 'Pridaj dôkaz',
        submissionModeVia: 'cez {{submissionMode}}',
        viewEvidence: 'Zobraziť dôkaz',
      },
      ReportList: {
        yourReports: 'Vaše správy',
      },
      ReportingActivate: {
        buttonText: 'Pokračovať',
        description:
          'Ak vás vaša organizácia registrovala na účet, pošleme vám email s pokynmi na dokončenie nastavenia.',
        emailInput: 'Email',
        header: 'Zadajte svoj pracovný e-mail',
        successAccount:
          'Ak vás vaša organizácia zaregistrovala na účet, pošleme vám e-mail s pokynmi na dokončenie nastavenia.',
        successEmail:
          'Ak to hneď nevidíte, počkajte prosím niekoľko minút a obnovte svoju e-mailovú schránku.',
        successHeading: 'Ďakujem',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Pridajte dôkazy do svojej správy',
        descriptionText:
          'Pridávanie súborov ako dôkazov môže podporiť efektivitu riešenia od vášho správcu prípadu. Zvážte obsah súboru (vrátane metadát súboru), ak chcete zostať anonymní a rešpektujte práva ostatných jednotlivcov a platné zákony. Pre viac informácií, prosím, pozrite si tento <a> pomocný článok </a>',
        emptyMessage: 'Žiadne ďalšie dôkazy neboli nahrané',
      },
      ReportingChangePassword: {
        back: 'Späť',
        description:
          'Vytvorte silné heslo na zabezpečenie vášho účtu. Začnite písať a nižšie uvidíte pokyny.',
        errorToast: 'Nemôžem vytvoriť heslo, neplatný token.',
        header: 'Zmeniť heslo',
        incorrectCurrentPassword:
          'Súčasné heslo je nesprávne. Skontrolujte ho a skúste to znova.',
        invalidToken: 'Neplatný token',
        passwordUpdated: 'Heslo aktualizované',
        passwordUpdatedDescription:
          'Vaše heslo bolo úspešne aktualizované. Ďakujeme, že ste urobili tento krok na zabezpečenie vašich dát!',
        passwordUsedBefore: 'Opätovné použitie hesla nie je povolené',
        passwordUsedBeforeDescription:
          'Pre vašu bezpečnosť nemôžete znovu použiť žiadne z vašich posledných šiestich hesiel. Prosím, vyberte si nové, jedinečné heslo, aby ste udržali svoj účet bezpečný a skúste to znova.',
        toastDescription:
          'Vaše heslo bolo úspešne aktualizované. Ďakujeme, že ste urobili tento krok na ochranu vašich údajov!',
        toastMessage: 'Heslo aktualizované',
        updatePasswordCTA: 'Aktualizovať heslo',
      },
      ReportingConnect: {
        cancelButton: 'Zrušiť',
        connectButton: 'Pripojiť',
        disclaimer:
          'Pripojenie vášho Slack účtu k vášmu účtu Vault zabezpečuje bezpečné a súkromné spojenie.<br /><br />Po pripojení môžete hlásiť nesprávne správanie alebo klásť otázku priamo v Slacku. Vždy budete mať možnosť nahlásiť anonymne po pripojení. Vaše súkromie a bezpečnosť sú našou najvyššou prioritou.',
        heading:
          'Vault Platform žiada o povolenie na prístup k vášmu Slack účtu {{organisationName}}',
        listHeading: 'Čo bude schopný Vault robiť?',
        permissionIdentity: {
          extraInfo:
            'Vault bude mať možnosť vidieť identitu vášho Slack používateľa.',
          heading: 'Zobraziť informácie o identite používateľa',
        },
        permissionNotifications: {
          extraInfo:
            'Vault bude schopný posielať vám oznámenia na váš Slack účet, týkajúce sa akýchkoľvek aktualizácií odoslaného správy alebo otázky.',
          heading: 'Posielať vám oznámenia',
        },
        permissionOverview: {
          extraInfo:
            'Vault zobrazí prehľad všetkých príspevkov na úvodnej stránke',
          heading: 'Prehľad podaní',
        },
        permissionSubmitReport: {
          extraInfo:
            'Toto Vaultovi udelí povolenie odoslať správu alebo položiť otázku priamo vašej organizácii zo Slacku.',
          heading: 'Podajte správu alebo otázku za vás',
        },
        successfulConnectionDescription:
          'Vaše účty Vault a Slack sú teraz prepojené. Teraz môžete zavrieť túto kartu a vrátiť sa do Slacku.',
        successfulConnectionHeading: 'Úspešne pripojený',
        unsuccessfulConnectionDescription:
          'Niečo sa pokazilo. Prosím, zatvorte túto kartu a vráťte sa na Slack a skúste to znova.',
        unsuccessfulConnectionHeading: 'Pripojenie zlyhalo',
      },
      ReportingForgotPassword: {
        description:
          'Zadajte e-mailovú adresu spojenú s vaším účtom a pošleme vám odkaz na obnovenie hesla.',
        heading: 'Zabudnuté heslo',
        invalidTokenError: 'Nemôžem vytvoriť heslo, neplatný token.',
        passwordReuseError: 'Opätovné použitie hesla nie je povolené',
        passwordReuseErrorDescription:
          'Pre vašu bezpečnosť nemôžete znovu použiť žiadne z vašich posledných šiestich hesiel. Prosím, vyberte si nové, jedinečné heslo, aby ste udržali svoj účet v bezpečí a skúste to znovu.',
        sendLink: 'Odoslať odkaz na obnovenie',
        sendLinkFailure: 'Niečo sa pokazilo',
        sendLinkFailureDescription:
          'Vráťte sa späť na <a>Reportérsky Hub</a> a skúste to znova. Ak sa problém nerieši, obráťte sa na nás na <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Odkaz na resetovanie hesla odoslaný',
        sendLinkSuccessDescription:
          'Poslali sme odkaz na obnovenie hesla na {{email}}',
        updatePasswordSuccess: 'Heslo aktualizované',
        updatePasswordSuccessDescription:
          'Vaše heslo bolo úspešne aktualizované. Ďakujeme, že ste urobili tento krok na zabezpečenie vašich dát!',
      },
      ReportingLogin: {
        accountFrozen: 'Účet je zmrazený',
        accountLocked:
          'Prihlásenie bolo pokúsené príliš veľakrát nesprávne. Účet je zamknutý na dobu až 1 hodiny. Počas tejto doby nie je možné resetovať heslo.',
        accountLockedPermanently:
          'Váš účet bol uzamknutý. Na obnovenie prístupu použite obnovenie hesla alebo sa obráťte na svojho systémového administrátora pre ďalšiu pomoc.',
        createAccountCTA: 'Zaregistrujte sa na účet',
        currentPassword: 'Aktuálne heslo',
        emailLabel: 'Vaša e-mailová adresa',
        forgotPassword: 'Zabudli ste heslo?',
        loginButton: 'Prihlásenie',
        newPasswordPlaceholder: 'Nové heslo',
        passwordFailMessage:
          'Vráťte sa späť do aplikácie Vault v Slacku a skúste to znova. Ak problém pretrváva, obráťte sa na nás na adrese techsupport@vaultplatform.com.',
        passwordFailTitle: 'Niečo sa pokazilo',
        passwordLabel: 'Vaše Heslo',
        passwordPlaceholder: 'Zadajte svoje heslo',
        passwordResetRequired: 'Je potrebné resetovať heslo',
        passwordSuccessfullySetMessage:
          'Vráťte sa späť do aplikácie Vault v Slack a overte sa pomocou vášho nového hesla, aby ste mohli pokračovať tam, kde ste skončili.',
        passwordSuccessfullySetTitle: 'Heslo úspešne nastavené',
        reenterPlaceholder: 'Zadajte heslo znova',
        title: 'Reporter Hub',
        tooltip:
          'Ak ste ešte nikdy nenastavili heslo pre aplikáciu Vault, postupujte podľa pokynov tu. Ak ste zabudli svoje heslo, použite odkaz "Zabudnuté heslo" nižšie.',
        usernameLoginFailed:
          'Prihlásenie zlyhalo, používateľské meno alebo heslo je nesprávne',
      },
      ReportingReset: {
        failureDescription:
          'Vráťte sa späť do aplikácie Vault v Slack a skúste to znova. Ak problém pretrváva, kontaktujte nás na adrese <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Niečo sa pokazilo',
        successDescription:
          'Vráťte sa späť do aplikácie Vault v Slack a autentifikujte sa pomocou svojho nového hesla, aby ste pokračovali tam, kde ste skončili.',
        successHeading: 'Heslo úspešne nastavené',
      },
      noReports: {
        description:
          'Všetky odoslané správy sa zobrazia tu. Dozviete sa viac o spôsoboch, ako môžete odosielať správu od Vaulta.',
        descriptionHelpArticle: 'tento pomocný článok',
        errorDescription:
          'Snažíme sa načítať vaše správy. Skúste obnoviť stránku.',
        errorDescriptionSecondary: 'Ak to nefunguje, obráťte sa na nás na',
        errorTitle: '⚠️ Ups, niečo sa pokazilo',
        title: 'Ešte nemáte žiadne správy.',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktivujte automatické preklady a čítajte všetky správy z reportu vo vašom preferovanom jazyku. Preklad jazyk je založený na jazyku vybranom na vašom zariadení.',
          autoTranslationDescription2:
            'Môžete prepínať medzi preloženým a pôvodným jazykom v každom rozhovore.',
          autoTranslationTitle:
            'Povoliť automatické preklady pre správy z reportu',
          header: 'Nastavenia správ',
          subHeader: 'Nakonfigurujte, ako sa zobrazujú správy',
        },
        notificationSettings: {
          emailDescription:
            'Prijať emailové upozornenia na dôležité aktualizácie vašich správ',
          emailTitle: 'Emailové oznámenia',
          header: 'Nastavenia oznámení',
          subHeader: 'Nakonfigurujte, ako chcete dostávať oznámenia',
        },
        title: 'Nastavenia',
        updatedSettingsFailure: 'Nepodarilo sa aktualizovať vaše nastavenia',
        updatedSettingsSuccess: 'Úspešne ste aktualizovali svoje nastavenia',
      },
    },
    validators: {
      passwordLength: 'Heslo musí mať aspoň 9 znakov',
      passwordLowercase: 'Heslo musí obsahovať aspoň 1 malé písmeno',
      passwordMissMatch:
        'Polia pre heslo a na potvrdenie hesla sa musia zhodovať.',
      passwordNumeric: 'Heslo musí obsahovať aspoň 1 číslo',
      passwordUppercase: 'Heslo musí obsahovať aspoň 1 veľké písmeno',
    },
    validatorsNew: {
      passwordLength: 'Medzi 10 a 30 znakmi',
      passwordLowercase: 'Aspoň jedno malé písmeno',
      passwordMissMatch: 'Heslá sa nezhodujú',
      passwordNumeric: 'Minimálne jedno číslo',
      passwordSpecialCharacter: 'Aspoň jeden špeciálny znak',
      passwordUppercase: 'Aspoň jedno veľké písmeno',
    },
  },
};

export default translations;
